import { Locale, useLocaleStore } from '../state/locale-store'

export function useLocale(ssrOverride?: Partial<Locale>) {
  // If we are on the server, we don't have access to the locale store, use the override
  if (typeof window === 'undefined' && ssrOverride) {
    return {
      locale: ssrOverride.locale ?? '',
      language: ssrOverride.language ?? '',
      country: ssrOverride.country ?? '',
    }
  }

  const locale = useLocaleStore((state) => state.locale)
  return {
    locale: locale.locale,
    language: locale.language,
    country: locale.country,
  }
}
